// extracted by mini-css-extract-plugin
module.exports = {"summary":"Detail_summary__6agiA"};